export default "__VITE_ASSET__ChG13yVK__"